import {
    ChangeDetectorRef,
    Component, EventEmitter, OnInit, Input, Output,
    ViewEncapsulation
} from '@angular/core';

import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {BaseComponent} from "../../../../../common/components/base.component";
import {config} from "../../../../../../config/config";
import {EventTimeService} from "../../../../../services/event.time.service";
import {ButtonTriggerEvent} from "../../../../../common/components";
import {CustomizationApiService} from "../../../../../services/customization.api.service";
import {HubApiService} from "../../../../../services/hub.api.service";
import {StyleCommand, StyleModel} from "../../../../../commands/hub/style.command";

@Component({
    selector: 'ig-trip-planner-color-settings',
    templateUrl: './trip.planner.color.settings.component.html',
    styleUrls: ['./trip.planner.color.settings.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TripPlannerColorSettingsComponent extends BaseComponent implements OnInit {
    public hubName = null;
    public defaultImg = config.defaultImageUrl;
    public tourSideImg = config.tripPlannerTourSideImg;
    public mapImg = config.mapImg;
    public tpBG = config.tripPlannerWelcomeImg;
    public timeSample = EventTimeService.convert(new Date());
    public previewSelectedTab = 'event';
    @Input() public style = new StyleModel();
    @Output() onSave: EventEmitter<{command: StyleCommand, event: ButtonTriggerEvent}> = new EventEmitter<{command: StyleCommand, event: ButtonTriggerEvent}>();

    constructor(private hubApiService: HubApiService,
                private formBuilder: FormBuilder,
                private activatedRoute: ActivatedRoute,
                private customizationService: CustomizationApiService,
                private cd: ChangeDetectorRef
    ) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;
    }

    public get leftPartWidth() {
        return this.isOnTourOrTrip ? '29%' : '60%';
    }

    public get rightPartWidth() {
        return this.isOnTourOrTrip ? '70%' : '39%';
    }

    public get isOnTourOrTrip() {
        return this.isOnTour || this.isOnTrip;
    }

    public get isOnTour() {
        return this.previewSelectedTab === 'tour';
    }

    public get isOnTrip() {
        return this.previewSelectedTab === 'trip';
    }

    public toDefault(type: 'event' | 'place' | 'tour' | 'trip' | 'buttons') {
        const defaultStyle = new StyleModel();
        this.style.tripPlanner[type].color.value = defaultStyle.tripPlanner[type].color.value;
    }

    public saveColor(event: ButtonTriggerEvent) {
        const colorCmd = new StyleCommand();
        Object.keys(colorCmd.tripPlanner).forEach(x => {
            colorCmd.tripPlanner[x].color = this.style.tripPlanner[x].color.isDefault ? '' : this.style.tripPlanner[x].color.value;
            delete colorCmd.tripPlanner[x].isDefault;
        });
        this.onSave.emit({command: colorCmd, event});
    }

    public chooseColor(){}
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/style/trip.planner.color.settings/trip.planner.color.settings.component.ts